import { createTheme } from '@material-ui/core/styles';

const vColor = '#622FEE';
const bColor = '#F4F4F4';
const tColor = '#FAFAFA';
const qColor = '#121212';
export default createTheme({
  palette: {
    common: {
      arcViolet: `${vColor}`,
    },
    primary: {
      main: `${vColor}`,
    },
    secondary: {
      main: `${bColor}`,
    },
    ternary: {
      main: `${tColor}`,
    },
    quad: {
      main: `${qColor}`,
    },
  },
  typography: {
    button: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '17px',
      textAlign: 'center',
      borderRadius: 0,
      height: '3.5em',
      textTransform: 'none',
    },
    body1: {
      fontWeight: 500,
      lineHeight: '17px',
      color: `${qColor}`,
      fontFamily: 'Montserrat',
    },
    caption: {
      fontFamily: 'Montserrat',
    },
  },
  overrides: {
    MuiSelect: {
      select: {
        paddingRight: '24px',
        paddingTop: '0px',
        paddingBottom: '0px',
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        color: `${vColor}`,
        '&$checked': {
          color: `${vColor}`,
        },
      },
    },
    MuiInputAdornment: {
      positionEnd: {
        marginLeft: '0px',
      },
    },
    MuiFormControl: {
      root: {
        width: '100%',
      },
    },
    MuiButton: {
      root: {
        borderRadius: 0,
        fontSize: '12px',
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 0,
      },
    },
    MuiAvatar: {
      root: {
        width: '27px !important',
        height: '27px !important',
      },
    },
    MuiBox: {
      root: { padding: '0' },
    },
    MuiPaper: {
      rounded: {
        borderRadius: '5px',
      },
    },
    MuiPopover: {
      paper: {
        minWidth: '7em',
        maxWidth: '50em',
      },
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: 'transparent',
      },
    },
    MuiCardContent: {
      root: {
        padding: '10px',
        width: 'auto',
        fontSize: '12px',
      },
    },
    MuiTab: {
      root: {
        fontWeight: 500,
        minWidth: '60px',
        '@media (min-width: 600px)': {
          minWidth: '60px',
        },
        '&$selected': {
          fontWeight: 600,
        },
      },
      textColorPrimary: {
        fontSize: '14px',
        fontWeight: 500,
        color: 'rgba(0, 0, 0, 0.4)',
      },
    },
    MuiCardHeader: {
      root: {
        padding: '0px',
      },
    },
    MuiMenuItem: {
      root: {
        color: '#000000',
        width: 'auto',
        overflow: 'hidden',
        fontSize: '1rem',
        boxSizing: 'borderBox',
        minHeight: '48px',
        fontFamily: 'Montserrat',
        fontWeight: '500',
        lineHeight: '17px',
        paddingTop: '6px',
        whiteSpace: 'nowrap',
        letterSpacing: '0.00938em',
        paddingBottom: '6px',
        justifyContent: 'end',
      },
    },
    MuiRadio: {
      colorSecondary: {
        color: '#98A2B3',
        '&$checked': {
          color: '#98A2B3',
        },
      },
    },
  },
});
